import clsx from 'clsx'
import React, { forwardRef, PropsWithChildren } from 'react'

import styles from './ProductTileWrapperMaxThree.module.scss'

interface ProductTileWrapperMaxThreeProps{
  className?: string
}
export const ProductTileWrapperMaxThree = forwardRef<HTMLDivElement, PropsWithChildren<ProductTileWrapperMaxThreeProps>>(({ children, className }, ref) => (
  <div
    className={clsx(styles.productTileWrapperMaxThree, className)}
    ref={ref}
  >
    {children}
  </div>
))

export const ProductTileWrapperMaxSeven = forwardRef<HTMLDivElement, PropsWithChildren<ProductTileWrapperMaxThreeProps>>(({ children, className }, ref) => (
  <div
    className={clsx(styles.productTileWrapperMaxSeven, className)}
    ref={ref}
  >
    {children}
  </div>
))
